module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customer name or number":"Customer name or number","last customers":"Last customers"},"de":{"customer name or number":"Kundenname bzw. Nummer","last customers":"Letzte Kunden"}}')
  delete Component.options._Ctor
}
